import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import NpsScalePopup from '../../../app/nps/scale';
import { TwoFaPopups } from '../auth/two-fa/two-fa-popups';
import { RenewAppleLicencePopup } from '../renew-apple-licence';
import { SubscriptionMessagePopup } from '../subscription/subscription-message';
// eslint-disable-next-line max-len
import { AccountRestrictedSoonContainer as AccountRestrictedSoonPopup } from '../onboarding/account-restricted-soon/account-restricted-soon-container';
export var BrandViewPopups = function () { return (_jsxs(_Fragment, { children: [_jsx(NpsScalePopup, {}), _jsx(TwoFaPopups, {}), _jsx(RenewAppleLicencePopup, {}), _jsx(SubscriptionMessagePopup, {}), _jsx(AccountRestrictedSoonPopup, {})] })); };
